/* BUCK DRINK theme JS: cart drawer (Shopify Ajax API), product page, menus. No dependencies. */
(function () {
  'use strict';
  var CG = window.CG || { routes: { cart: '/cart', add: '/cart/add', change: '/cart/change', product: '/collections/all' }, moneyFormat: '${{amount}}', freeShip: 15000 };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money (mirrors Shopify's money_format) ---------- */
  function money(cents) {
    var format = CG.moneyFormat || '${{amount}}';
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format); var type = m ? m[1] : 'amount';
    function fmt(n, precision, thousands, decimal) {
      var s = (Number(n) / 100).toFixed(precision); var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var v;
    switch (type) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) { var t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2200); }

  /* ---------- drawers ---------- */
  function lock() { var c = $('#cartDrawer'), m = $('#mobileNav'); document.body.classList.toggle('locked', (c && c.classList.contains('on')) || (m && m.classList.contains('on'))); }
  function openCart() { var d = $('#cartDrawer'); if (!d) return; d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); $('#cartOverlay').classList.add('on'); lock(); }
  function closeCart() { var d = $('#cartDrawer'); if (!d) return; d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); $('#cartOverlay').classList.remove('on'); lock(); }
  function openMenu() { var n = $('#mobileNav'); if (!n) return; n.classList.add('on'); n.setAttribute('aria-hidden', 'false'); $('#menuOverlay').classList.add('on'); lock(); }
  function closeMenu() { var n = $('#mobileNav'); if (!n) return; n.classList.remove('on'); n.setAttribute('aria-hidden', 'true'); $('#menuOverlay').classList.remove('on'); lock(); }

  /* ---------- cart ---------- */
  function cartImg(item) {
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!src) return '';
    return src.replace(/(\.(?:jpe?g|png|gif|webp))(\?.*)?$/i, '_144x144_crop_center$1$2');
  }
  function renderCart(cart) {
    var count = $('#cartCount'); if (count) count.textContent = cart.item_count;
    var ship = $('#cartShip');
    if (ship) {
      var left = CG.freeShip - cart.total_price;
      var pct = Math.min(100, CG.freeShip ? (cart.total_price / CG.freeShip) * 100 : 100);
      ship.innerHTML = (left > 0 ? 'You are <b>' + money(left) + '</b> away from free shipping' : '<b>Free shipping unlocked.</b> Well done.') + '<div class="bar"><i style="width:' + pct + '%"></i></div>';
    }
    var lines = $('#cartLines');
    if (lines) {
      if (!cart.items.length) {
        lines.innerHTML = '<div class="empty"><p>Your cart is empty.</p><a class="btn ghost" href="' + esc(CG.routes.product) + '" data-close-cart>GET THE BUCK DRINK</a></div>';
      } else {
        lines.innerHTML = cart.items.map(function (it, i) {
          var img = cartImg(it);
          var meta = (it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '') + (it.quantity > 1 ? ' · Qty ' + it.quantity : '');
          return '<div class="line" data-line="' + (i + 1) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : '<div></div>') +
            '<div><div class="n">' + esc(it.product_title) + '</div><div class="m">' + meta + '</div><button type="button" class="rm" data-remove="' + (i + 1) + '">Remove</button></div>' +
            '<div class="lp">' + money(it.final_line_price) + '</div></div>';
        }).join('');
      }
    }
    var sub = $('#cartSubtotal'); if (sub) { sub.textContent = money(cart.total_price); sub.setAttribute('data-cents', cart.total_price); }
    var form = $('#cartCheckoutForm'); if (form) form.hidden = !cart.items.length;
  }
  function getCart() { return fetch(CG.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  /* Open the drawer at once with what we already know (title, price, image), then confirm
     with the server. Two round trips used to happen before anything moved on screen. */
  function showPending(preview) {
    if (!preview || !preview.length) return;
    openCart();
    var lines = $('#cartLines'); if (!lines) return;
    var empty = $('.empty', lines); if (empty) empty.remove();
    var html = preview.map(function (p) {
      return '<div class="line pending">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '<div></div>') +
        '<div><div class="n">' + esc(p.title) + '</div><div class="m">' + esc(p.meta || '') + '</div></div>' +
        '<div class="lp">' + money(p.price) + '</div></div>';
    }).join('');
    lines.insertAdjacentHTML('afterbegin', html);
    var sub = $('#cartSubtotal'), add = preview.reduce(function (a, p) { return a + (p.price || 0); }, 0);
    if (sub) { var cur = parseFloat(String(sub.getAttribute('data-cents') || '0')) || 0; sub.textContent = money(cur + add); }
    var form = $('#cartCheckoutForm'); if (form) form.hidden = false;
  }
  function addItems(items, preview) {
    /* open the drawer at once on every path; the product page also shows the line straight away */
    if (preview) showPending(preview); else openCart();
    return fetch(CG.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body && (res.body.description || res.body.message) || 'Could not add to cart'); return getCart().then(renderCart).then(function () { return false; }); }
        return getCart().then(function (c) { renderCart(c); return true; });
      })
      .catch(function () { toast('Could not add to cart'); return getCart().then(renderCart).then(function () { return false; }, function () { return false; }); });
  }
  function removeLine(line) {
    return fetch(CG.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: 0 }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Could not update cart'); });
  }

  /* ---------- product page ---------- */
  function fmtDate(d) {
    var m = d.toLocaleDateString('en-US', { month: 'short' }); var day = d.getDate();
    var s = day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th';
    return m + ' ' + day + s;
  }
  function plusDays(k) { var d = new Date(); d.setDate(d.getDate() + k); return d; }

  /* BEST VALUE ring: one canvas, text drawn round a rounded-rect path each frame.
     Replaces ~100 individually animated spans, which iOS runs on the main thread. */
  function buildRing(box, ring) {
    var unit = ring.getAttribute('data-text') || 'BEST VALUE • ';
    var coarse = window.matchMedia && window.matchMedia('(pointer:coarse)').matches;
    var SPEED = 40, ADV = coarse ? 8.2 : 7.4, FONT_PX = coarse ? 10.5 : 9.5;
    var canvas = document.createElement('canvas'); canvas.className = 'ringc';
    ring.innerHTML = ''; ring.appendChild(canvas);
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    var W = 0, H = 0, dpr = 1, pts = [], per = 0, n = 0, glyphs = [], font = '';
    function build() {
      W = box.offsetWidth; H = box.offsetHeight; if (!W || !H) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      var R = 20, inset = 9, r = R - inset, L = inset, Tp = inset, Rt = W - inset, B = H - inset;
      pts = [];
      function line(x0, y0, x1, y1) { var k = Math.max(2, Math.round(Math.hypot(x1 - x0, y1 - y0) / 3)); for (var i = 0; i < k; i++) { var t = i / k; pts.push({ x: x0 + (x1 - x0) * t, y: y0 + (y1 - y0) * t }); } }
      function arc(cx, cy, a0, a1) { for (var i = 0; i < 10; i++) { var t = a0 + (a1 - a0) * i / 10; pts.push({ x: cx + r * Math.cos(t), y: cy + r * Math.sin(t) }); } }
      line(L + r, Tp, Rt - r, Tp); arc(Rt - r, Tp + r, -Math.PI / 2, 0);
      line(Rt, Tp + r, Rt, B - r); arc(Rt - r, B - r, 0, Math.PI / 2);
      line(Rt - r, B, L + r, B); arc(L + r, B - r, Math.PI / 2, Math.PI);
      line(L, B - r, L, Tp + r); arc(L + r, Tp + r, Math.PI, Math.PI * 1.5);
      var d = 0;
      for (var i = 0; i < pts.length; i++) { var p = pts[i], q = pts[(i + 1) % pts.length]; p.s = d; p.a = Math.atan2(q.y - p.y, q.x - p.x); d += Math.hypot(q.x - p.x, q.y - p.y); }
      per = d;
      var k = Math.max(1, Math.round(per / (unit.length * ADV))); n = unit.length * k;
      glyphs = []; for (var j = 0; j < n; j++) glyphs.push(unit[j % unit.length]);
      font = '900 ' + FONT_PX + 'px "Arial Black","Helvetica Neue",Arial,sans-serif';
    }
    function at(dist) {
      dist = ((dist % per) + per) % per;
      var lo = 0, hi = pts.length - 1;
      while (lo < hi) { var mid = (lo + hi + 1) >> 1; if (pts[mid].s <= dist) lo = mid; else hi = mid - 1; }
      var p = pts[lo], q = pts[(lo + 1) % pts.length], seg = Math.hypot(q.x - p.x, q.y - p.y) || 1, t = (dist - p.s) / seg;
      return { x: p.x + (q.x - p.x) * t, y: p.y + (q.y - p.y) * t, a: p.a };
    }
    var off = 0, last = 0, pending = false;
    function frame(now) {
      pending = false;
      if (!per) { schedule(); return; }
      var idle = document.hidden || box.classList.contains('paused');
      if (idle) { last = 0; schedule(); return; }
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 0; last = now; off += SPEED * dt;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
      ctx.font = font; ctx.fillStyle = '#fff'; ctx.textBaseline = 'middle'; ctx.textAlign = 'center';
      for (var i = 0; i < n; i++) {
        var pos = at(off + (i / n) * per);
        ctx.save(); ctx.translate(pos.x, pos.y); ctx.rotate(pos.a); ctx.fillText(glyphs[i], 0, 0); ctx.restore();
      }
      schedule();
    }
    function schedule() { if (pending) return; pending = true; requestAnimationFrame(frame); }
    build(); schedule();
    if (window.ResizeObserver) new ResizeObserver(function () { var w = box.offsetWidth, h = box.offsetHeight; if (Math.abs(w - W) > 1 || Math.abs(h - H) > 1) build(); }).observe(box);
  }

  function initProduct() {
    var page = $('[data-product-page]'); if (!page) return;
    var tiers = $$('[data-tier]', page);
    function selected() { return $('[data-tier].sel', page) || tiers[0]; }
    function total() {
      var t = selected(); if (!t) return 0;
      var sum = Number(t.getAttribute('data-price')) || 0;
      $$('.ax:checked', t).forEach(function (c) { sum += Number(c.getAttribute('data-price')) || 0; });
      return sum;
    }
    function refresh() {
      var t = selected(); var p = $('#stickyPrice'); if (p) p.textContent = money(total());
      var soldout = t && t.hasAttribute('data-soldout');
      $$('[data-atc]').forEach(function (b) { b.disabled = !!soldout; if (soldout) b.textContent = 'SOLD OUT'; else if (b.textContent === 'SOLD OUT') b.textContent = 'ADD TO CART'; });
    }
    function selectTier(el) { tiers.forEach(function (t) { t.classList.toggle('sel', t === el); }); refresh(); }
    tiers.forEach(function (t) { t.addEventListener('click', function () { if (!t.classList.contains('sel')) selectTier(t); }); });
    $$('.ax', page).forEach(function (c) { c.addEventListener('change', refresh); });
    refresh();

    var adding = false;
    function addToCart() {
      if (adding) return; var t = selected(); if (!t || t.hasAttribute('data-soldout')) return;
      var items = [{ id: Number(t.getAttribute('data-variant')), quantity: 1 }];
      var img = $('.mini img', t), title = page.getAttribute('data-product-title') || '', nm = $('.nm', t);
      var preview = [{ title: title, meta: nm ? nm.textContent.trim() : '', price: Number(t.getAttribute('data-price')) || 0, image: img ? img.currentSrc || img.src : '' }];
      $$('.ax:checked', t).forEach(function (c) {
        items.push({ id: Number(c.getAttribute('data-addon')), quantity: 1 });
        var row = c.closest('.axrow'), ri = row && $('img', row);
        preview.push({ title: row ? row.textContent.replace(/^\s*\+\s*Add\s*/, '').replace(/\s*[A-Z]{0,3}\$[\d.,]+\s*$/, '').trim() : 'Add-on', meta: '', price: Number(c.getAttribute('data-price')) || 0, image: ri ? ri.currentSrc || ri.src : '' });
      });
      adding = true;
      var main = $('#atc'), label = main ? main.textContent : '';
      if (main) main.textContent = 'ADDED ✓';
      addItems(items, preview).then(function (ok) {
        adding = false;
        if (main) { if (ok) setTimeout(function () { main.textContent = label || 'ADD TO CART'; }, 1150); else main.textContent = label || 'ADD TO CART'; }
      });
    }
    $$('[data-atc]').forEach(function (b) { b.addEventListener('click', addToCart); });

    /* best value ring */
    var best = $('.tier.best', page); var ring = best && $('[data-ring]', best);
    if (best && ring) buildRing(best, ring);

    /* gallery */
    var track = $('#sliderTrack'), slides = track ? $$('.slide', track) : [], n = slides.length, cur = 0, slider = $('#slider');
    var dots = $('#slideDots');
    if (dots) dots.innerHTML = slides.map(function (_, i) { return '<button type="button" aria-label="Image ' + (i + 1) + '" data-goto="' + i + '"' + (i === 0 ? ' class="on"' : '') + '></button>'; }).join('');
    function go(i) {
      if (!n) return; cur = ((i % n) + n) % n;
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      var c = $('#slideCount'); if (c) c.textContent = (cur + 1) + ' / ' + n;
      $$('#slideDots button').forEach(function (b, k) { b.classList.toggle('on', k === cur); });
      $$('#slideThumbs button').forEach(function (b, k) { b.classList.toggle('sel', k === cur); });
    }
    $$('[data-slide]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(cur + Number(b.getAttribute('data-slide'))); }); });
    page.addEventListener('click', function (e) { var g = e.target.closest('[data-goto]'); if (g) go(Number(g.getAttribute('data-goto'))); });
    if (slider && track) {
      var drag = null, raf = 0;
      function paint() {
        raf = 0; if (!drag) return;
        track.style.transform = 'translateX(calc(-' + cur * 100 + '% + ' + drag.dx + 'px))';
      }
      slider.addEventListener('pointerdown', function (e) {
        if (e.button) return;
        /* never capture on a control: pointer capture retargets the click to the
           capturing element, which kills the prev/next arrows inside the slider */
        if (e.target.closest('button, a, input')) return;
        drag = { x: e.clientX, dx: 0, id: e.pointerId };
        track.classList.add('dragging');
        if (slider.setPointerCapture) { try { slider.setPointerCapture(e.pointerId); } catch (err) {} }
      });
      slider.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        drag.dx = e.clientX - drag.x;
        if (!raf) raf = requestAnimationFrame(paint);
      });
      function end(e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        track.classList.remove('dragging');
        var dx = drag.dx; drag = null;
        if (Math.abs(dx) > 60) go(cur + (dx < 0 ? 1 : -1)); else go(cur);
      }
      slider.addEventListener('pointerup', end); slider.addEventListener('pointercancel', end);
      $$('img', slider).forEach(function (im) { im.draggable = false; });
    }

    /* reviews carousel */
    var rt = $('#revTrack'), rs = rt ? $$('.rslide', rt) : [], ri = 0, rTimer;
    function goRev(i) { if (!rs.length) return; ri = ((i % rs.length) + rs.length) % rs.length; rt.style.transform = 'translateX(-' + ri * 100 + '%)'; $$('#revDots button').forEach(function (b, k) { b.classList.toggle('on', k === ri); }); }
    $$('[data-rev]').forEach(function (b) { b.addEventListener('click', function () { goRev(Number(b.getAttribute('data-rev'))); clearInterval(rTimer); }); });
    if (rs.length > 1 && !reduced) rTimer = setInterval(function () { goRev(ri + 1); }, 5500);

    /* timeline dates */
    $$('[data-date]').forEach(function (el) {
      var v = el.getAttribute('data-date').split('-').map(Number);
      el.textContent = v.length > 1 ? fmtDate(plusDays(v[0])) + ' - ' + fmtDate(plusDays(v[1])) : fmtDate(plusDays(v[0]));
    });

    /* sticky bar */
    var atc = $('#atc'), sticky = $('#stickyBar');
    if (atc && sticky && window.IntersectionObserver) {
      new IntersectionObserver(function (en) { var b = en[0]; sticky.classList.toggle('up', !b.isIntersecting && b.boundingClientRect.top < 0); }, { threshold: 0 }).observe(atc);
    }
  }

  /* ---------- global delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-open-cart]'))) { e.preventDefault(); openCart(); return; }
    if ((el = t.closest('[data-close-cart]'))) { if (el.tagName !== 'A') e.preventDefault(); closeCart(); return; }
    if ((el = t.closest('[data-open-menu]'))) { e.preventDefault(); openMenu(); return; }
    if ((el = t.closest('[data-close-menu]'))) { if (el.tagName !== 'A') e.preventDefault(); closeMenu(); return; }
    if ((el = t.closest('[data-toggle-search]'))) { e.preventDefault(); var sb = $('#searchbar'); if (sb) { sb.classList.toggle('open'); if (sb.classList.contains('open')) { var inp = $('input', sb); if (inp) inp.focus(); } } return; }
    if ((el = t.closest('[data-add]'))) { e.preventDefault(); e.stopPropagation(); if (el.disabled) return; el.disabled = true; addItems([{ id: Number(el.getAttribute('data-add')), quantity: 1 }]).then(function () { el.disabled = false; }); return; }
    if ((el = t.closest('[data-remove]'))) { e.preventDefault(); removeLine(Number(el.getAttribute('data-remove'))); return; }
    if ((el = t.closest('.faq .q > button'))) {
      var q = el.parentNode, open = q.classList.toggle('open'), a = $('.a', q);
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });
  var trackForm = $('[data-track-form]');
  if (trackForm) trackForm.addEventListener('submit', function (e) { e.preventDefault(); var num = (new FormData(trackForm).get('tracking') || '').toString().trim(); if (num) window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener'); });

  /* ---------- pause looping animations while off screen ---------- */
  function pauseOffscreen() {
    if (!window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('paused', !en.isIntersecting); });
    }, { rootMargin: '120px' });
    $$('.announce, .banner, .wave, .atc, .bvframe').forEach(function (el) { io.observe(el); });
  }

  /* the narrow layout shows a still instead of the loop: don't decode the video behind it */
  function heroVideoGuard() {
    var v = $('.banner .bgvid'); if (!v || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width:820px)');
    function sync() {
      if (mq.matches) { if (!v.paused) v.pause(); }
      else if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    sync();
    /* autoplay can start after this runs, so catch it on the way in too */
    v.addEventListener('play', function () { if (mq.matches) v.pause(); });
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  }

  /* ---------- phones: vertical scroll only ----------
     CSS touch-action does most of it; these catch older iOS that ignores the viewport tag. */
  function lockViewport() {
    document.addEventListener('gesturestart', function (e) { e.preventDefault(); }, { passive: false });
    document.addEventListener('gesturechange', function (e) { e.preventDefault(); }, { passive: false });
    document.addEventListener('touchmove', function (e) { if (e.scale !== undefined && e.scale !== 1) e.preventDefault(); }, { passive: false });
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = $$('.reveal'); if (!els.length) return;
    if (reduced || !window.IntersectionObserver) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { threshold: 0, rootMargin: '0px 0px 120px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  initProduct();
  pauseOffscreen();
  initReveal();
  lockViewport();
  heroVideoGuard();
})();
